import * as React from "react";
import { navigate } from "~/router";
import { useCreateProduct } from "~/apps/pos/apis/products";
import ProductFormOverlay from "./ProductFormOverlay";
import { ProductRequest } from "~/apps/pos/models";
import { useRoute } from "react-router5";
import { getProductFilter, getProductParams } from "~/apps/pos/shared/services/qsfilter";
import { connect } from "react-redux";

const ProductCreatePopup = ({ locationId }) => {
  const { route } = useRoute();
  const filter = getProductFilter(route.params);

  const { mutate: onCreate, error, isLoading } = useCreateProduct();

  const handleClose = () => {
    navigate("pos.admin.products.all-products", getProductParams(filter));
  };

  const handleSubmit = (data: ProductRequest) => {
    onCreate(data, {
      onSuccess: () => {
        handleClose();
      },
    });
  };

  const initialValues = {
    name: "",
    type: "",
    locationId: locationId || "",
    categoryId: "",
    groupId: "",
    priority: null,
    price: "",
  };

  return (
    <ProductFormOverlay
      initialValues={initialValues}
      title="New product"
      error={error?.message || error?.errorMessage || ""}
      isLoading={isLoading}
      onSubmit={handleSubmit}
      onClose={handleClose}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    locationId: state.shared.auth.currentUser.locationId,
  };
};

export default connect(mapStateToProps)(ProductCreatePopup);
